import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useRef, useCallback, useEffect } from 'react';
/**
 * useThrottle
 * Throttles a function with a timeout and ensures
 * that the callback function runs at most once in that duration
 * @param fn The callback to throttle
 * @param timeout Throttle timeout
 */

function useThrottle(fn) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      ready = _useState2[0],
      setReady = _useState2[1];

  var timerRef = useRef(undefined);

  if (!fn || typeof fn !== "function") {
    throw new Error("As a first argument, you need to pass a function to useThrottle hook.");
  }

  var throttledFn = useCallback(function () {
    if (!ready) {
      return;
    }

    setReady(false);
    fn.apply(void 0, arguments);
  }, [ready, fn]);
  useEffect(function () {
    if (!ready) {
      timerRef.current = window.setTimeout(function () {
        setReady(true);
      }, timeout);
      return function () {
        return window.clearTimeout(timerRef.current);
      };
    }
  }, [ready, timeout]);
  return [throttledFn, ready];
}

export default useThrottle;